import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Form from 'root/module/form';
import Modals from 'root/modals';
import View from 'root/view/base';

var Clickup_Send = View.extend({
    send_options: null,

    team_id      : '',
    space_id     : '',
    list_id      : '',

    assignee_id  : '',
    status_id    : '',
    priority_id  : '',

    list_statuses: {},

    form_value : {
        title: ''
    },

    events: {
        'click .dropdown-space li'    : 'onSelectSpace',
        'click .dropdown-list li'     : 'onSelectList',
        'click .dropdown-assignee li' : 'onSelectAssignee',
        'click .dropdown-status li'   : 'onSelectStatus',
        'click .dropdown-priority li' : 'onSelectPriority',
        'click .reconnect'            : 'onReconnect',
        'submit form'                 : 'onSubmit'
    },

    dom_handlers: {
        onSelectSpace: function(e) {
            var space_id = $(e.currentTarget).data('key');

            if (space_id != this.space_id) {
                this.space_id = space_id;
                this.renderSpaces();

                var lists = this.getLists(space_id);
                this.list_id  = lists.length ? lists[0].id : '';
                this.renderLists();

                this.status_id = '';
                this.renderStatuses();

                this.priority_id = '';
                this.renderPriorities();
            }
        },

        onSelectList: function(e) {
            var list_id = $(e.currentTarget).data('key');

            if (list_id != this.list_id) {
                this.list_id = list_id;
                this.renderLists();

                this.status_id = '';
                this.renderStatuses();
            }
        },

        onSelectAssignee: function(e) {
            var assignee_id = $(e.currentTarget).data('key');

            if (assignee_id != this.assignee_id) {
                this.assignee_id = assignee_id;
                this.renderAssignees();
            }
        },

        onSelectStatus: function(e) {
            var status_id = $(e.currentTarget).data('key');

            if (status_id != this.status_id) {
                this.status_id = status_id;
                this.renderStatuses();
            }
        },

        onSelectPriority: function(e) {
            var priority_id = $(e.currentTarget).data('key');

            if (priority_id != this.priority_id) {
                this.priority_id = priority_id;
                this.renderPriorities();
            }
        },

        onReconnect: function(e) {
            var connected_app = Cache.connected_app_oauth.get(Cache.integration_clickup.findWhere({project_id: this.model.get('project_id')})?.get('app_id') || 0);

            if (connected_app) {
                Modals.reconnectConnectedApp(connected_app.get('app_type'), connected_app, () => {
                    Modals.sendToClickup(this.model.id);
                });
            } else {
                window.parent.location = '/account/connected_app';
            }
        },

        onSubmit: function(e) {
            var form_data = Form.getData(this.$el.find('form'));

            this.$el.find('button[type="submit"]').prop('disabled', true).addClass('loading');

            this.$el.find('.mask-light').show();
            this.$el.find('.progress-loader').width('0%').show();

            var progress = 0;
            var timeout = setInterval(function() {
                progress = Math.min(90, progress + Math.random() * 15);
                this.$el.find('.progress-loader').width(progress + '%');
            }.bind(this), 50);

            Cache.app.request({
                action: 'integration/sendFeedbackToClickup',
                context: this,
                data: _.extend(form_data, {
                    feedback_id : this.model.get('id'),
                    list_id     : this.list_id,
                    assignee_id : this.assignee_id,
                    status      : this.status_id ? this.searchStatus(this.space_id, this.list_id, this.status_id)['status'] : '',
                    priority_id : this.priority_id
                }),
                success: function(response) {
                    this.model.set('clickup_url', response.clickup_url);

                    setTimeout(function() {
                        UI.success('Task created in ClickUp');
                        this.trigger('submit:success');
                    }.bind(this), 800);
                },
                complete: function() {
                    this.$el.find('button[type="submit"]').prop('disabled', false).removeClass('loading');

                    clearInterval(timeout);
                    this.$el.find('.progress-loader').width('100%');
                }
            });
        }
    },

    initialize: function() {
        this.form_value  = {
            title: ''
        };

        if (this.model.isDesign() || this.model.isPdf() || this.model.isVideoUpload()) {
            this.title = 'Feedback for ' + this.model.get('page');
        } else {
            this.title = 'Feedback #' + Util.padLeft(this.model.id, '000000');
        }

        if (this.model.get('title')) {
            this.form_value.title = this.model.get('title');
        }

        this.list_id = Cache.integration_clickup.findWhere({project_id: this.model.get('project_id')})?.get('clickup_list_id') || 0;
    },

    searchTeam: function(team_id) {
        var result = null;

        if (this.send_options) {
            this.send_options.teams.forEach(function(team) {
                if (team.id == team_id) {
                    result = team;
                }
            });
        }

        return result;
    },

    searchSpace: function(space_id) {
        var result = null;

        if (this.send_options) {
            this.send_options.spaces.forEach(function(space) {
                if (space.id == space_id) {
                    result = space;
                }
            });
        }

        return result;
    },

    searchList: function(space_id, list_id) {
        var result = null;

        if (this.send_options && this.send_options.lists[space_id]) {
            this.send_options.lists[space_id].forEach(function(list) {
                if (list.id == list_id) {
                    result = list;
                }
            });
        }

        return result;
    },

    searchAssignee: function(team_id, assignee_id) {
        var result = null;
        var team = this.searchTeam(team_id);

        if (team) {
            team.members.forEach(function(member) {
                if (member.id == assignee_id) {
                    result = member;
                }
            });
        }

        return result;
    },

    searchStatus: function(space_id, list_id, status_id) {
        var result = null;

        this.getStatuses(space_id, list_id).forEach(function(status) {
            if (status.id == status_id) {
                result = status;
            }
        });

        return result;
    },

    searchPriority: function(space_id, priority_id) {
        var result = null;

        this.getPriorities(space_id).forEach(function(priority) {
            if (priority.id == priority_id) {
                result = priority;
            }
        });

        return result;
    },

    getSpaces: function(team_id) {
        var spaces = [];

        if (this.send_options) {
            this.send_options.spaces.forEach(function(space) {
                if (space.team_id == team_id) {
                    spaces.push(space);
                }
            });
        }

        return spaces;
    },

    getLists: function(space_id) {
        if (this.send_options && this.send_options.lists[space_id]) {
            return this.send_options.lists[space_id];
        } else {
            return [];
        }
    },

    getStatuses: function(space_id, list_id) {
        var space = this.searchSpace(space_id);
        var list  = this.searchList(space_id, list_id);

        if (this.list_statuses[list_id] && this.list_statuses[list_id].length) {
            return this.list_statuses[list_id];
        } else if (space && space.statuses.length) {
            return space.statuses;
        }

        return [];
    },

    getPriorities: function(space_id) {
        return this.searchSpace(space_id)['priorities'];
    },

    loadSetting: function() {
        Cache.app.request({
            action: 'integration/loadSendOptions',
            data: {
                type: 'clickup_setting',
                project_id: this.model.get('project_id')
            },
            context: this,
            success: function(response) {
                if (response.space_id) {
                    this.space_id = response.space_id;
                }

                this.loadSendOptions();
            }
        });
    },

    loadStatus: function(list_id) {
        Cache.app.request({
            action: 'integration/loadSendOptions',
            data: {
                type: 'clickup_list_status',
                project_id: this.model.get('project_id'),
                list_id: list_id
            },
            context: this,
            success: function(response) {
                this.list_statuses[list_id] = response;
                this.renderStatuses();
            }
        });
    },

    loadLists: function(space_id) {
        Cache.app.request({
            action: 'integration/loadSendOptions',
            data: {
                type: 'clickup_lists',
                access_token : this.access_token,
                project_id: this.model.get('project_id'),
                space_id: space_id
            },
            context: this,
            success: function(response) {
                this.send_options.lists[space_id] = response;

                // validate list id
                if (this.list_id) {
                    var list = this.searchList(this.space_id, this.list_id);
                    if (!list) {
                        this.list_id = '';
                    }
                }

                // default to the first list
                if (!this.list_id && response.length) {
                    this.list_id = response[0].id;
                }

                //this.renderSpaces();
                this.renderLists();
                this.renderAssignees();
                this.renderStatuses();
                this.renderPriorities();
            }
        });
    },

    loadSendOptions: function() {
        Cache.app.request({
            action: 'integration/loadSendOptions',
            data: {
                type : 'clickup',
                project_id: this.model.get('project_id')
            },
            context: this,
            success: function(response) {
                if (!response.lists.length && !response.spaces.length && !response.teams.length) {
                    var html = '<div class="error-dialog padding-60">' +
                                    '<div class="icon"><i class="fas fa-exclamation"></i></div>' +
                                    '<h3>Authentication failed</h3>' +
                                    '<p class="info">Your ClickUp account couldn\'t be connected.</p>' +
                                    (Cache.app.isAdmin() ?
                                    '<button class="reconnect primary medium">Reconnect ClickUp</button>' : '') +
                                '</div>';

                    this.$el.html(html);
                } else {
                    this.send_options = response;

                    if (!this.space_id && this.send_options.spaces.length) {
                        this.space_id = this.send_options.spaces[0].id;
                    }

                    // valid space id
                    var space = this.searchSpace(this.space_id);

                    if (!space && this.send_options.spaces.length) {
                        this.space_id = this.send_options.spaces[0].id;
                    }

                    if (this.space_id && !this.team_id) {
                        this.send_options.spaces.forEach((space) => {
                            if (space.id == this.space_id) {
                                this.team_id  = space.team_id;
                            }
                        });
                    }

                    this.renderSpaces();
                    this.renderLists();
                    this.renderStatuses();
                    this.renderAssignees();
                    this.renderPriorities();
                }
            },
            complete: function() {
                this.$el.find('form button:submit').prop('disabled', false);
            }
        });
    },

    renderSpaces: function() {
        var space_items = '';
        var space = this.searchSpace(this.space_id);

        this.getSpaces(this.team_id).forEach(function(option) {
            space_items += '<li data-key="' + Util.htmlEntities(option.id) + '"' + (option.id == this.space_id ? ' class="selected"' : '') + '>' +
                                Util.htmlEntities(option.name) +
                            '</li>';
        }.bind(this));

        if (!space_items) {
            space_items += '<li class="disabled">No spaces found</li>';
        }

        this.$el.find('.region-spaces').html(
            '<div class="field-label">Space <i class="fas fa-asterisk"></i></div>' +
            '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-space">' +
                '<button type="button" class="dropdown-select"><img class="icon-img" src="/image/clickup_small.png">' + (space ? Util.htmlEntities(space.name) : '<span class="placeholder-text">No space selected</span>') + '</button>' +
                '<div>' +
                    '<div class="dropdown-search">' +
                        '<input type="text" class="solid compact" placeholder="Search by space name">' +
                    '</div>' +
                    '<ul class="dropdown dropdown-select">' + space_items + '</ul>' +
                '</div>' +
            '</div>'
        );

        this.$el.find('.region-due-dates').toggle(space && space.has_due_dates);
    },

    renderLists: function() {
        var is_list_loaded = this.send_options.lists[this.space_id] ? true : false;

        // space is good, team is good, now let's load list
        if (!is_list_loaded) {
            this.loadLists(this.space_id);
        }

        var list_folders = [];
        var list_items = '';
        var list = this.searchList(this.space_id, this.list_id);

        this.getLists(this.space_id).forEach((option) => {
            if (option.folder && list_folders.indexOf(option.folder) === -1) {
                list_folders.push(option.folder);
            } else if (!option.folder) {
                // no folder lists
                list_items += '<li data-key="' + Util.htmlEntities(option.id) + '"' + (option.id == this.list_id ? ' class="selected"' : '') + '>' +
                                  Util.htmlEntities(option.name) +
                              '</li>';
            }
        });

        // folder lists
        list_folders.forEach((folder, index) => {
            if (index > 0 || list_items) {
                list_items += '<li class="separator"></li>';
            }

            list_items += '<li class="dropdown-title"><i class="fa-solid fa-folder-open ignore"></i> ' + Util.htmlEntities(folder) + '</li>';

            this.getLists(this.space_id).forEach((option) => {
                if (option.folder === folder) {
                    list_items += '<li data-key="' + Util.htmlEntities(option.id) + '"' + (option.id == this.list_id ? ' class="selected"' : '') + '>' +
                                      Util.htmlEntities(option.name) +
                                  '</li>';
                }
            });
        });

        if (!list_items) {
            list_items += '<li class="disabled">No lists found</li>';
        }

        this.$el.find('.region-lists').html(
            '<div class="field-label">List <i class="fas fa-asterisk"></i></div>' +

            (is_list_loaded ?
            '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-list">' +
                '<button type="button" class="dropdown-select">' + (list ? Util.htmlEntities(list.name) : '<span class="placeholder-text">No lists selected</span>') + '</button>' +
                '<div>' +
                    '<div class="dropdown-search">' +
                        '<input type="text" class="solid compact" placeholder="Search by list name">' +
                    '</div>' +
                    '<ul class="dropdown dropdown-select">' + list_items + '</ul>' +
                '</div>' +
            '</div>' :
            '<div class="loader-placeholder-medium"></div>')
        );
    },

    renderAssignees: function() {
        var team     = this.searchTeam(this.team_id);
        var assignee = this.searchAssignee(this.team_id, this.assignee_id);

        var assignee_items = '<li data-key=""' + (!this.assignee_id ? ' class="selected"' : '') + '><img class="icon-img icon-img-round" src="/image/profile.png">Unassigned</li>';

        if (team) {
            team.members.forEach(function(option) {
                assignee_items += '<li data-key="' + Util.htmlEntities(option.id) + '"' + (option.id == this.assignee_id ? ' class="selected"' : '') + '>' +
                                        '<img class="icon-img icon-img-round" src="' + (option.profilePicture || Util.gravatar('', 32, option.initials)) + '">' +
                                        Util.htmlEntities(option.username || option.email) +
                                    '</li>';
            }.bind(this));
        }

        this.$el.find('.region-assignees').html(
            '<div class="field-label">Assign to</div>' +
            '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-assignee" data-append="true">' +
                '<button type="button" class="dropdown-select">' +
                    (assignee ?
                    '<img class="icon-img icon-img-round" src="' + (assignee.profilePicture || Util.gravatar('', 32, assignee.initials)) + '">' + Util.htmlEntities(assignee.username) :
                    '<img class="icon-img icon-img-round" src="/image/profile.png"><span class="placeholder-text">Unassigned</span>') +
                    '</button>' +
                '<div>' +
                    '<div class="dropdown-search">' +
                        '<input type="text" class="solid compact" placeholder="Search by name">' +
                    '</div>' +
                    '<ul class="dropdown dropdown-select">' + assignee_items + '</ul>' +
                '</div>' +
            '</div>'
        );
    },

    renderStatuses: function() {
        var is_status_loaded = this.list_statuses[this.list_id] ? true : false;

        if (!is_status_loaded) {
            this.loadStatus(this.list_id);
        }

        var status = this.searchStatus(this.space_id, this.list_id, this.status_id);

        var status_items = '';

        this.getStatuses(this.space_id, this.list_id).forEach(function(option) {
            status_items += '<li data-key="' + Util.htmlEntities(option.id) + '"' + (option.id == this.status_id ? ' class="selected"' : '') + '>' +
                                '<i class="fas fa-circle fa-xs" style="color:' + option.color + ';"></i>' +
                                '<span class="cap">' + Util.htmlEntities(option.status) + '</span>' +
                            '</li>';
        }.bind(this));

        this.$el.find('.region-statuses').html(
            '<div class="field-label">Status</div>' +
            (is_status_loaded ?
            '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-status" data-append="true">' +
                '<button type="button" class="dropdown-select">' +
                (status ?
                    '<i class="fas fa-circle fa-xs margin-right-4" style="color:' + status.color + ';"></i><span class="cap">' + Util.htmlEntities(status.status) + '</span>' :
                    '<span class="placeholder-text">Select status</span>') +
                '</button>' +
                '<div>' +
                    '<ul class="dropdown dropdown-select">' + status_items + '</ul>' +
                '</div>' +
            '</div>' :
            '<div class="loader-placeholder-medium"></div>')
        );
    },

    renderPriorities: function() {
        var priority = this.searchPriority(this.space_id, this.priority_id);

        var priority_items = '';

        this.getPriorities(this.space_id).forEach(function(option) {
            priority_items += '<li data-key="' + Util.htmlEntities(option.id) + '"' + (option.id == this.priority_id ? ' class="selected"' : '') + '>' +
                                    '<i class="fas fa-circle fa-xs" style="color:' + option.color + ';"></i>' +
                                    '<span class="cap">' + Util.htmlEntities(option.priority) + '</span>' +
                                '</li>';
        }.bind(this));

        if (priority_items) {
            this.$el.find('.region-priorities').html(
                '<div class="field-label">Priority</div>' +
                '<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-priority" data-append="true">' +
                    '<button type="button" class="dropdown-select">' +
                    (priority ?
                        '<i class="fas fa-circle fa-xs" style="color:' + priority.color + ';"></i> <span class="cap">' + Util.htmlEntities(priority.priority) + '</span>' :
                        '<span class="placeholder-text">Select priority</span>') +
                    '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select">' +
                            priority_items +
                            (priority ?
                            '<li class="separator"></li>' +
                            '<li data-key=""><i class="fas fa-times fa-xs" style="color:#E80000;"></i>Clear</li>' : '') +
                        '</ul>' +
                    '</div>' +
                '</div>'
            );

            this.$el.find('.region-priorities').show();
        } else {
            this.$el.find('.region-priorities').hide();
        }
    },

    render: function() {
        var content = '';

        content += '<div class="progress-loader"></div>';
        content += '<div class="mask-light" style="display:none;"></div>';

        content += '<form class="form-fluid">' +
                        '<div class="modal-integration-innerscroll">' +
                            '<div class="row-50">' +
                                '<div class="region-spaces">' +
                                    '<div class="field-label">Space <i class="fas fa-asterisk"></i></div>' +
                                    '<div class="loader-placeholder loader-placeholder-medium"></div>' +
                                '</div>' +
                                '<div class="region-lists">' +
                                    '<div class="field-label">List <i class="fas fa-asterisk"></i></div>' +
                                    '<div class="loader-placeholder loader-placeholder-medium"></div>' +
                                '</div>' +
                            '</div>' +
                            '<div class="row">' +
                                '<div class="field-label">Title</div>' +
                                '<input type="text" name="title" maxlength="255" class="solid compact" placeholder="' + Util.htmlEntities(this.title) + '">' +
                            '</div>' +
                            '<div class="row">' +
                                '<div class="field-label">Description</div>' +
                                '<textarea name="description" class="solid compact" rows="3"></textarea>' +
                            '</div>' +
                            '<div class="row region-statuses">' +
                                '<div class="field-label">Status</div>' +
                                '<div class="loader-placeholder loader-placeholder-medium"></div>' +
                            '</div>' +
                            '<div class="row region-priorities" style="display:none;">' +
                                '<div class="field-label">Priority</div>' +
                                '<div class="loader-placeholder loader-placeholder-medium"></div>' +
                            '</div>' +
                            '<div class="row region-assignees">' +
                                '<div class="field-label">Assign to</div>' +
                                '<div class="loader-placeholder loader-placeholder-medium"></div>' +
                            '</div>' +
                            '<div class="row region-due-dates">' +
                                '<div class="field-label">Due Date</div>' +
                                '<input type="date" name="due_date" class="solid compact">' +
                            '</div>' +
                        '</div>' +

                        '<div class="modal-integration-innerscroll-footer">' +
                            '<button type="submit" class="primary" disabled>Send</button>' +
                        '</div>' +
                    '</form>';

        this.$el.html(content);

        if (this.form_value.title) {
            Form.setData(this.$el.find('form'), {
                title: this.form_value.title
            });
        }

        if (this.model.get('due_date')) {
            Form.setData(this.$el.find('form'), {
                due_date: Util.moment(this.model.get('due_date'), 'YYYY-MM-DD', false, false)
            });
        }

        if (!this.send_options) {
            this.loadSetting();
        }

        return this;
    }
});

export default Clickup_Send;